import {useQuery} from "@tanstack/react-query";
import {qk} from "@queries/keys";
import PointsCapService from "@lib/PointsCap/PointsCapService";

export const useUserPointsCap = () => {
    return useQuery({
        queryKey: qk.pointsCapCheck(),
        queryFn: () => PointsCapService.checkUserCap(),
        staleTime: 0,
        retry: false,
        refetchOnMount: true,
        refetchOnWindowFocus: true,
        refetchInterval: 5 * 60_000,
    });
};
